import React from "react";
import TopNavbar from "./TopNavbar";
import BottomNavbar from "./BottomNavbar";

const Navbar = () => {
  return (
    <div className="sticky -top-10 z-10">
      <TopNavbar />
      <BottomNavbar />
    </div>
  );
};

export default Navbar;
